export default {
  getServiceFormById: (state) => (formType) => {
    let servicesForm = state['servicesForm']

      if(servicesForm?.hasOwnProperty(formType)){
        return servicesForm[formType]
      }
      return null
    },
    

  getServicesForm: (state) => ()=> {
    return state.servicesForm
  },

  getUserId: (state) => () => {
    return state.userId
  },

  getMedia: (state) => (module) => {
    return state.media[module]
  },



  getSelectedServices: (state) => () => {
    return state.selectedServices
  },

}
